import React from "react";
import { Link } from "react-router-dom";
import { BsGithub, BsLinkedin } from "react-icons/bs";
import { SiHashnode } from "react-icons/si";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer container-narrow">
      <div className="divider"></div>
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
        <div>
          <h5 className="mb-1">Aritra Bhattacharjee</h5>
          <p className="muted">Building web apps, ML prototypes, and developer-friendly products.</p>
          <p className="muted mb-0">&#169; {year} Aritra Bhattacharjee. All rights reserved.</p>
        </div>
        <div className="d-flex gap-3 align-items-center">
          <Link className="tag" to="/projects">Projects</Link>
          <Link className="tag" to="/blogs">Writing</Link>
          <Link className="tag" to="/contact">Contact</Link>
        </div>
        <div className="d-flex gap-3">
          <a href="https://www.linkedin.com/in/aritra-bhattacharjee/" target="_blank" rel="noreferrer">
            <BsLinkedin />
          </a>
          <a href="https://github.com/AritraBhattacharjee" target="_blank" rel="noreferrer">
            <BsGithub />
          </a>
          <a href="https://hashnode.com/@AritraBhattacharjee" target="_blank" rel="noreferrer">
            <SiHashnode />
          </a>
        </div>
      </div>
    </footer>
  );
}
